import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { color } from '../templates/Ui';
import { getAppThemeName } from '../../services/appTheme';
const RadioWrapper = styled.div `
    position: relative;
    margin-bottom: 10px;

    &:first-child&:last-child {
        margin: 0;
    }

    ${props => props.variant === 'button' &&
    css `
            margin-right: 10px;
        `};
`;
const StyledInput = styled.input `
    position: absolute;
    top: 5px;
    left: 3px;
    margin: 0;
    padding: 0;
    height: auto;
    width: auto;
    opacity: 0;

    &:checked + label {
        color: ${props => props.theme.primary.base};
        font-weight: 600;

        &:before {
            border-color: ${props => props.theme.secondary};
            background-color: ${props => props.theme.secondary};
        }

        &:after {
            opacity: 1;
        }
    }

    &:checked:disabled + label {
        color: #a0a0a0;

        &:before {
            background-color: #a0a0a0;
            border-color: #a0a0a0;
        }
    }

    ${props => props.variant === 'button' &&
    css `
            &:checked + label {
                color: white;
                font-weight: 600;
            }
        `};

    ${props => props.variant === 'button' &&
    props.appTheme === 'invoned' &&
    css `
            &:checked + label {
                color: ${props => props.theme.primary.dark};
                font-weight: 600;
            }
        `};
`;
const StyledLabel = styled.label `
    transition: color 150ms ease-in-out;
    display: inline-block;
    padding: 5px 0 5px 30px;
    vertical-align: middle;
    color: #6f6f6e;
    font-weight: 400;
    cursor: pointer;
    user-select: none;

    &:before {
        transition: all 150ms ease-in-out;
        position: absolute;
        content: '';
        width: 20px;
        height: 20px;
        left: 0;
        top: 5px;
        border-radius: 15px;
        background-color: #ffffff;
        border: 1px solid #dfe0e8;
    }

    &:after {
        transition: all 150ms ease-in-out;
        position: absolute;
        content: '';
        width: 10px;
        height: 10px;
        left: 6px;
        top: 11px;
        background-repeat: no-repeat;
        background-color: white;
        opacity: 0;
        border-radius: 5px;
    }

    ${props => props.variant === 'button' &&
    css `
            display: flex;
            justify-content: center;
            padding: 15px;
            min-width: 115px;
            color: ${props => props.theme.primary.base};

            span {
                position: relative;
                z-index: 1;
            }

            &:before {
                width: 100%;
                min-height: 40px;
                font-size: 14px;
                border-radius: 6px;
                background-color: ${color.border.base};
                border-color: ${color.border.base};
            }

            &:after {
                display: none;
            }
        `};
`;
const Radio = ({ label, id, variant, name, ...props }) => {
    const [fid] = useState(id || _.uniqueId('field-'));
    return (_jsx(_Fragment, { children: _jsxs(RadioWrapper, { variant: variant, children: [_jsx(StyledInput, { type: "radio", id: fid, variant: variant, name: name, appTheme: getAppThemeName(), ...props }), _jsx(StyledLabel, { htmlFor: fid, variant: variant, children: _jsx("span", { children: label }) })] }) }));
};
export default Radio;
